import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Text from '../../../shared/Text';

export const Container = styled.div`
  background: ${themeGet('colors.white')};
  border: 1px solid ${themeGet('colors.black.10')};
  border-radius: 8px;
`;

export const Header = styled(Text)`
  height: 42px;
  padding: 0 24px;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  display: flex;
  align-items: center;
`;

export const Name = styled.div``;

export const TableHeader = styled.li`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  padding: 20px;
`;
